<template>
  <q-list>

    <q-item tag="label" class="q-px-none">
      <q-item-section avatar top>
        <q-checkbox v-model="authorizations" val="auth_1" dense></q-checkbox>
      </q-item-section>
      <q-item-section>
        <q-item-label class="text-100 text-blue-grey-8 q-mb-md">
          I understand that I am authorizing {{ plan_brand(selected_plan) }} to become my Retail Electric Provider and
          that a move-in or switch can only be made by the electric service applicant or the applicant's authorized
          agent. I authorize {{ plan_brand(selected_plan) }} to take the necessary steps to switch me from my current
          provider. I have read and understand this offer and the Terms of Services linked below. I am at least 18 years
          of age and legally authorized to change to a new Retail Electric Provider.
        </q-item-label>
      </q-item-section>
    </q-item>

    <q-item tag="label" class="q-px-none">
      <q-item-section avatar top>
        <q-checkbox v-model="authorizations" val="auth_2" dense></q-checkbox>
      </q-item-section>
      <q-item-section>
        <q-item-label class="text-100 text-blue-grey-8 q-mb-md">
          I have read and understand the information contained in this enrollment, including the
          <a :href="plan_doc_link(selected_plan, 'tos')" target="_blank" class="cp-non-link">Terms of Service</a>.
        </q-item-label>
      </q-item-section>
    </q-item>

    <q-item tag="label" class="q-px-none">
      <q-item-section avatar top>
        <q-checkbox v-model="authorizations" val="auth_3" dense></q-checkbox>
      </q-item-section>
      <q-item-section>
        <q-item-label class="text-100 text-blue-grey-8 q-mb-md">
          I consent to the use of electronic records and signatures including the provision of state and federal
          disclosures in place of written documentation and handwritten signatures in connection with my enrollment
          application.
        </q-item-label>
      </q-item-section>
    </q-item>

  </q-list>
</template>

<script>
import SelectedPlan from "src/composables/SelectedPlan";
import Utilities from "src/composables/Utilities";
import { computed, ref, watch } from "vue";

export default {
  name: "ConstellationAuthorizations",
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { selected_plan } = SelectedPlan();
    const { plan_brand, plan_doc_link } = Utilities();
    const authorizations = ref([]);

    watch(authorizations, () => {
      const agreed = authorizations.value.length === 3
      emit('update:modelValue', agreed);
    })

    return {
      authorizations,
      selected_plan,

      plan_brand,
      plan_doc_link
    }
  }
}
</script>

<style scoped>

</style>
